<template>
  <div>

  </div>
</template>

<script>
import { AUTH_LOGOUT } from '@/store/actions/auth'

export default {
  name: 'Logout',
  created () {
    this.$store.dispatch(AUTH_LOGOUT)
    this.$router.push('/')
  }
}
</script>

<style scoped>
.login-wrapper {
  animation: fadein 0.6s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>



// WEBPACK FOOTER //
// src/components/users/Logout.vue